import React from "react";
import './NavBar.css'
import { useNavigate } from "react-router-dom"; // Use useNavigate from v6

export default function NavBar() {
  const navigate = useNavigate();

  const handleLogout = () =>{
    //console.log("Logged out");
    localStorage.removeItem("token"); 
    navigate("/login");
  }
  return (
    <nav className="navbar custom-navbar fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand me-5 m-3" href="/">eBadge Distribution</a>
        <div className="navbar-nav d-flex flex-row">
          <a className="nav-link active me-3" aria-current="page" href="/">Main Operations</a>
          <a className="nav-link active me-3" aria-current="page" href="/bulk-operations">Bulk Operations</a>
          <a className="nav-link me-3" href="/badge-store">Badge Store</a>
        </div>
        <button onClick={()=>handleLogout()} className="btn btn-outline-danger me-3" style={{marginLeft:350}}>Logout</button>
      </div>
    </nav>
  );
}